import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PortalShell } from "@/components/portal/PortalShell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const NAV = [{ to: "/app/portal", label: "Meine Projekte" }];

export const Route = createFileRoute("/_authenticated/app/portal")({
  ssr: false,
  head: () => ({ meta: [{ title: "Kundenportal" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: PortalPage,
});

function PortalPage() {
  const { data: customer } = useQuery({
    queryKey: ["portal-customer"],
    queryFn: async () => {
      const { data: u } = await supabase.auth.getUser();
      const { data } = await supabase.from("customers").select("*").eq("portal_user_id", u.user!.id).maybeSingle();
      return data;
    },
  });

  const { data: projects } = useQuery({
    queryKey: ["portal-projects"],
    queryFn: async () => {
      const { data } = await supabase.from("projects").select("id, project_no, name, status, created_at").order("created_at", { ascending: false });
      return data ?? [];
    },
  });

  return (
    <PortalShell nav={NAV}>
      <h1 className="text-2xl font-semibold mb-6">Willkommen in Ihrem Portal</h1>

      {!customer && (
        <Card className="mb-6">
          <CardHeader><CardTitle className="text-base">Konto noch nicht freigeschaltet</CardTitle></CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Ihr Konto wurde erstellt, ist aber noch keinem Kundendatensatz zugeordnet.
              Bitte warten Sie, bis unser Team Ihr Portal freischaltet, oder kontaktieren Sie uns über die <Link to="/" className="underline">Startseite</Link>.
            </p>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardHeader><CardTitle className="text-base">Meine Projekte</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow><TableHead>Nr.</TableHead><TableHead>Projekt</TableHead><TableHead>Status</TableHead><TableHead>Erstellt</TableHead><TableHead></TableHead></TableRow></TableHeader>
            <TableBody>
              {(projects ?? []).map((p) => (
                <TableRow key={p.id}>
                  <TableCell className="font-mono text-xs">{p.project_no}</TableCell>
                  <TableCell>{p.name}</TableCell>
                  <TableCell>{p.status}</TableCell>
                  <TableCell>{new Date(p.created_at).toLocaleDateString("de-DE")}</TableCell>
                  <TableCell>
                    <Link to="/app/projects/$id/uploads" params={{ id: p.id }} className="text-sm underline">
                      Dokumente
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
              {(projects ?? []).length === 0 && (
                <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">Noch keine Projekte sichtbar.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </PortalShell>
  );
}
